import { Stack } from '@awazevr/design-system.components.stack'

import {
  StyledPropertyLocation,
  StyledPropertyName,
  StyledPropertyType,
} from './PropertyInfo.styles'

export type PropertyInfoProps = {
  propertyType?: string
  propertyLocation?: string | null
  propertyName?: string | null
  showPropertyType?: boolean
}

export const PropertyInfo = ({
  propertyType,
  propertyLocation,
  propertyName,
  showPropertyType = true,
}: PropertyInfoProps): JSX.Element => {
  return (
    <Stack direction={'column'} spacing={0}>
      {propertyType && showPropertyType && (
        <StyledPropertyType sizes={100} color="ColorStatusInfo500">
          {propertyType}
        </StyledPropertyType>
      )}

      {propertyLocation && (
        <StyledPropertyLocation sizes={300} mb={0} title={propertyLocation}>
          {propertyLocation}
        </StyledPropertyLocation>
      )}

      {propertyName && (
        <StyledPropertyName
          sizes={200}
          color="ColorGrey600"
          title={propertyName}
        >
          {propertyName}
        </StyledPropertyName>
      )}
    </Stack>
  )
}
